import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../utils/axios";
const initialState = {
  data: [],
  loading: false,
  message: "",
  completed: false,
  hasError: false,
};

export const fetchCreateNbcuSettingsData = createAsyncThunk(
  "createCreateNbcuSettingsData/fetchCreateNbcuSettingsData",
  async ({ data, id }) => {

    const response = await axiosInstance.request({
      url: `/settings/nbcuweighting`,
      method: `POST`,
      data: { ...data },
    });
    return response;
  }
);

const createCreateNbcuSettingsDataSlice = createSlice({
  name: "createCreateNbcuSettingsData",
  initialState,
  reducers: {
    clearData: () => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchCreateNbcuSettingsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCreateNbcuSettingsData.fulfilled, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.data = action.payload.data;
      })
      .addCase(fetchCreateNbcuSettingsData.rejected, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.hasError = true;
        state.message = action.error.message;
      });
  },
});

const CreateNbcuSettingsDataReducer = createCreateNbcuSettingsDataSlice.reducer;

export default CreateNbcuSettingsDataReducer;

export const createCreateNbcuSettingsDataAction =
  createCreateNbcuSettingsDataSlice.actions;
